var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9401 14.1093C23.9401 15.6394 22.6941 16.8853 21.1641 16.8853H6.06006V5.89066C6.06006 4.36059 7.30598 3.11467 8.83605 3.11467H23.9401V14.1093Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.022 11.2896H20.1695C20.2023 11.2896 20.2788 11.2787 20.3116 11.2787C20.5302 11.235 20.716 11.0383 20.716 10.765C20.716 10.5027 20.5302 10.306 20.3116 10.2514C20.2788 10.2404 20.2132 10.2404 20.1695 10.2404H19.022V11.2896Z",
    fill: "url(#paint0_linear_225_1867)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0384 4.04382C18.9454 4.04382 18.0493 4.92908 18.0493 6.03292V8.09852H20.858C20.9236 8.09852 21.0001 8.09852 21.0548 8.10945C21.6886 8.14223 22.1586 8.47011 22.1586 9.03842C22.1586 9.48651 21.8417 9.86903 21.2515 9.94553V9.96739C21.8963 10.0111 22.3881 10.3718 22.3881 10.9292C22.3881 11.5303 21.8417 11.9237 21.1203 11.9237H18.0383V15.9675H20.9564C22.0493 15.9675 22.9455 15.0822 22.9455 13.9784V4.04382H20.0384Z",
    fill: "url(#paint1_linear_225_1867)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5739 9.16931C20.5739 8.90701 20.3881 8.73215 20.1695 8.69936C20.1477 8.69936 20.093 8.68843 20.0602 8.68843H19.022V9.65019H20.0602C20.093 9.65019 20.1586 9.65019 20.1695 9.63926C20.3881 9.60647 20.5739 9.43161 20.5739 9.16931Z",
    fill: "url(#paint2_linear_225_1867)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04373 4.04382C7.95082 4.04382 7.05463 4.92908 7.05463 6.03292V10.9401C7.61201 11.2133 8.19126 11.3882 8.7705 11.3882C9.45903 11.3882 9.83062 10.9729 9.83062 10.4046V8.08759H11.5356V10.3936C11.5356 11.2898 10.9782 12.0221 9.08744 12.0221C7.93989 12.0221 7.0437 11.7707 7.0437 11.7707V15.9565H9.96177C11.0547 15.9565 11.9509 15.0713 11.9509 13.9674V4.04382H9.04373Z",
    fill: "url(#paint3_linear_225_1867)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5409 4.04382C13.4479 4.04382 12.5518 4.92908 12.5518 6.03292V8.63404C13.0545 8.20781 13.9288 7.93458 15.3387 8.00016C16.0928 8.03294 16.9015 8.2406 16.9015 8.2406V9.08214C16.4972 8.87448 16.0163 8.68869 15.3933 8.64497C14.3223 8.56847 13.6775 9.09307 13.6775 10.0111C13.6775 10.9401 14.3223 11.4647 15.3933 11.3772C16.0163 11.3335 16.4972 11.1368 16.9015 10.9401V11.7816C16.9015 11.7816 16.1037 11.9893 15.3387 12.0221C13.9288 12.0876 13.0545 11.8144 12.5518 11.3882V15.9784H15.4698C16.5627 15.9784 17.4589 15.0931 17.4589 13.9893V4.04382H14.5409Z",
    fill: "url(#paint4_linear_225_1867)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_225_1867",
    x1: 18.0475,
    y1: 10.7663,
    x2: 22.9587,
    y2: 10.7663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_225_1867",
    x1: 18.0473,
    y1: 10.0009,
    x2: 22.9589,
    y2: 10.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_225_1867",
    x1: 18.0473,
    y1: 9.16794,
    x2: 22.9588,
    y2: 9.16794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_225_1867",
    x1: 7.05232,
    y1: 10.0009,
    x2: 12.0396,
    y2: 10.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_225_1867",
    x1: 12.5235,
    y1: 10.0009,
    x2: 17.3673,
    y2: 10.0009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.e33f04e7.svg";
export { ForwardRef as ReactComponent };